import React from 'react';
import PropTypes from 'prop-types';

import BoardMember from 'components/BoardMember';
import OnPageEditing from 'components/OnPageEditing';

import css from './BoardBlock.module.scss';

class BoardBlock extends React.PureComponent {
    static propTypes = {
        downloadImageLabel: PropTypes.string.isRequired,
        heading: PropTypes.string.isRequired,
        items: PropTypes.arrayOf(PropTypes.shape(BoardMember.propTypes)),
    }

    render() {
        const {
            downloadImageLabel,
            heading,
            items,
        } = this.props;

        return (
            <div className={css.block}>
                <div className={css.content}>
                    <OnPageEditing property="Heading">
                        <header className={css.header}>
                            {heading && <h2 className="block-title-large">{heading}</h2>}
                        </header>
                    </OnPageEditing>
                    <OnPageEditing property="Items">
                        <ul className={css.items}>
                            {items.map((item, key) => (
                                <li key={key}>
                                    <BoardMember
                                        downloadImageLabel={downloadImageLabel}
                                        {...item}
                                    />
                                </li>
                            ))}
                        </ul>
                    </OnPageEditing>
                </div>
            </div>
        );
    }
}

export default BoardBlock;



// WEBPACK FOOTER //
// ./src/components/BoardBlock/BoardBlock.jsx